import { render, staticRenderFns } from "./addGroupModal.vue?vue&type=template&id=549a1c7f&"
import script from "./addGroupModal.vue?vue&type=script&lang=ts&"
export * from "./addGroupModal.vue?vue&type=script&lang=ts&"
import style0 from "./addGroupModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports